import DownhillSkiingIcon from "@mui/icons-material/DownhillSkiing";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import FoodBankIcon from "@mui/icons-material/FoodBank";
import LocalFloristIcon from "@mui/icons-material/LocalFlorist";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import PanoramaIcon from "@mui/icons-material/Panorama";
import PetsIcon from "@mui/icons-material/Pets";
import PhishingIcon from "@mui/icons-material/Phishing";
import RoundaboutRightIcon from "@mui/icons-material/RoundaboutRight";
import ScubaDivingIcon from "@mui/icons-material/ScubaDiving";
import SportsGolfIcon from "@mui/icons-material/SportsGolf";
import WavesIcon from "@mui/icons-material/Waves";

const airportTags = [
  {
    name: "City",
    icon: LocationCityIcon,
    airports: [
      "AKL",
      "AMS",
      "ATH",
      "ATL",
      "BCN",
      "BDA",
      "BEY",
      "BKK",
      "BMA",
      "BNE",
      "BOS",
      "BRU",
      "BWI",
      "CCU",
      "CDG",
      "CIA",
      "CMN",
      "CNS",
      "CNX",
      "CPH",
      "CPT",
      "CTS",
      "CUN",
      "DCA",
      "DEL",
      "DPS",
      "DXB",
      "XNB",
      "EDI",
      "EYW",
      "FCO",
      "FLL",
      "FLR",
      "FRA",
      "FRA",
      "GOT",
      "GRR",
      "HEL",
      "HKG",
      "HKT",
      "HND",
      "HNL",
      "ICN",
      "IND",
      "IST",
      "JFK",
      "KEF",
      "KRK",
      "KUL",
      "LGW",
      "LGA",
      "MDT",
      "MEX",
      "MIA",
      "MNL",
      "MUC",
      "MUC",
      "MUC",
      "NRT",
      "ORD",
      "ORD",
      "OSL",
      "PEK",
      "PHL",
      "PHX",
      "PNH",
      "PRG",
      "PTY",
      "RAK",
      "RKV",
      "RSW",
      "SAN",
      "SAT",
      "SFO",
      "SIN",
      "SJD",
      "SJU",
      "STN",
      "SVQ",
      "TLV",
      "TMB",
      "WLG",
      "YHU",
      "YHZ",
      "YQB",
      "YTO",
      "YTZ",
      "YUL",
      "YVR",
      "YYJ",
      "YYZ",
      "ZQN",
      "ZRH",
      "MAD",
      "LGA",
      "MUC",
      "YVR",
      "MIA",
      "ATL",
      "DXB",
      "XNB",
      "ORD",
    ],
  },
  {
    name: "Beach",
    icon: WavesIcon,
    airports: [
      "AIT",
      "AST",
      "AUA",
      "AYT",
      "BDA",
      "BGI",
      "BOB",
      "CCC",
      "CFU",
      "CHQ",
      "CNS",
      "CPT",
      "CUN",
      "DPS",
      "DXB",
      "FLL",
      "GCM",
      "GIG",
      "GOA",
      "GPS",
      "HKT",
      "HNL",
      "HTI",
      "JMK",
      "JTR",
      "KBV",
      "KKE",
      "KOS",
      "LAX",
      "LGK",
      "LIH",
      "LIR",
      "LNY",
      "MBA",
      "MBJ",
      "MIA",
      "MLE",
      "MMY",
      "MNL",
      "MPH",
      "MRU",
      "MRY",
      "MYR",
      "MZB",
      "NAN",
      "NAP",
      "NCE",
      "NOB",
      "NOS",
      "OGG",
      "OOL",
      "PBI",
      "PIU",
      "PLS",
      "POP",
      "PPS",
      "PQC",
      "PUJ",
      "PVR",
      "PXM",
      "RTB",
      "SAN",
      "SEZ",
      "SJD",
      "SJO",
      "SJU",
      "SRQ",
      "SSA",
      "STT",
      "TRA",
      "TRV",
      "USM",
      "VRA",
      "XQP",
      "YAZ",
      "YYJ",
      "ZNZ",
    ],
  },
  {
    name: "Family",
    icon: FamilyRestroomIcon,
    airports: [
      "AKL",
      "AMS",
      "ARN",
      "ATH",
      "BDA",
      "BKK",
      "BMA",
      "BOS",
      "BRU",
      "BTV",
      "BUD",
      "CCU",
      "CDG",
      "CGN",
      "CIA",
      "CMN",
      "CNS",
      "CNX",
      "CPH",
      "CUN",
      "DCA",
      "DUB",
      "DUS",
      "DXB",
      "XNB",
      "EDI",
      "EYW",
      "FAT",
      "FLL",
      "FLR",
      "GOT",
      "GRR",
      "HAN",
      "HEL",
      "HKG",
      "HKT",
      "HND",
      "HNL",
      "IAD",
      "ICN",
      "IND",
      "IST",
      "KEF",
      "KRK",
      "KUL",
      "LCY",
      "LHR",
      "MCO",
      "MDT",
      "MIA",
      "MUC",
      "NAS",
      "NBO",
      "NRT",
      "NYO",
      "OGG",
      "OOL",
      "OSL",
      "PHL",
      "PHX",
      "PNH",
      "PRG",
      "PTY",
      "RAK",
      "RKV",
      "RSW",
      "SAN",
      "SAT",
      "SFO",
      "SIG",
      "SIN",
      "SJU",
      "STN",
      "SVQ",
      "SYD",
      "TLV",
      "TMB",
      "VIE",
      "WIL",
      "WLG",
      "YHU",
      "YTO",
      "YTZ",
      "YUL",
      "YVR",
      "YYJ",
      "YYZ",
      "ZQN",
    ],
  },
  {
    name: "Honeymoon",
    icon: LocalFloristIcon,
    airports: [
      "AEP",
      "AGP",
      "AMS",
      "ASE",
      "BCN",
      "BGO",
      "BHB",
      "BUD",
      "BVA",
      "CHS",
      "CIA",
      "CPT",
      "DPS",
      "DXB",
      "XNB",
      "EDI",
      "EYW",
      "EZE",
      "FCO",
      "FLR",
      "GIG",
      "GND",
      "HKT",
      "HNL",
      "HTI",
      "IST",
      "JFK",
      "JTR",
      "KEF",
      "KIX",
      "LGA",
      "LJU",
      "MDZ",
      "MLE",
      "MRU",
      "MRY",
      "MSY",
      "NAN",
      "NAP",
      "OGG",
      "ORY",
      "PLS",
      "PPT",
      "PRG",
      "PUJ",
      "RAK",
      "RKV",
      "SAV",
      "SAW",
      "SEZ",
      "SFO",
      "SJO",
      "TPA",
      "UVF",
      "VCE",
      "WLG",
      "YHU",
      "YUL",
      "YYT",
      "ZQN",
    ],
  },
  {
    name: "Foodie",
    icon: FoodBankIcon,
    airports: [
      "AEP",
      "AGP",
      "AMS",
      "ANU",
      "ASE",
      "BCN",
      "BGO",
      "BUD",
      "BVA",
      "CDG",
      "CHS",
      "CIA",
      "CPT",
      "DBV",
      "DPS",
      "DXB",
      "XNB",
      "EYW",
      "EZE",
      "FLR",
      "GIG",
      "HKT",
      "IST",
      "JTR",
      "KEF",
      "KIX",
      "LGA",
      "LJU",
      "MDZ",
      "MRU",
      "MRY",
      "MSY",
      "NAN",
      "OGG",
      "ORY",
      "PLS",
      "PPT",
      "PRG",
      "PUJ",
      "RAK",
      "SAW",
      "SDU",
      "SEZ",
      "SJO",
      "SYD",
      "TPA",
      "UVF",
      "VCE",
      "VIE",
      "WLG",
      "YHU",
      "YQB",
      "ZNZ",
      "ZQN",
    ],
  },
  {
    name: "Skiing",
    icon: DownhillSkiingIcon,
    airports: [
      "ASE",
      "BGO",
      "BGR",
      "BRN",
      "BTV",
      "BZN",
      "CHC",
      "CTS",
      "DEN",
      "DRO",
      "EGE",
      "FCA",
      "GNB",
      "GRX",
      "GUC",
      "GVA",
      "HDN",
      "INN",
      "JAC",
      "LYS",
      "MMH",
      "MUC",
      "MXP",
      "NGO",
      "RNO",
      "SAF",
      "SCL",
      "SIR",
      "SLC",
      "SMV",
      "SUN",
      "SZG",
      "TEX",
      "TRN",
      "VCE",
      "YKA",
      "YVR",
      "YXC",
      "YYC",
      "ZRH",
    ],
  },
  {
    name: "Off beaten path",
    icon: RoundaboutRightIcon,
    airports: [
      "AKL",
      "ARK",
      "ATA",
      "BBA",
      "BDP",
      "BGO",
      "BHK",
      "BKO",
      "BOO",
      "BRI",
      "BRU",
      "BSL",
      "BZE",
      "CGB",
      "CHC",
      "CMB",
      "CUN",
      "DRW",
      "DYU",
      "EBB",
      "FAE",
      "FEN",
      "HAV",
      "HBA",
      "HBE",
      "HND",
      "ICN",
      "IQT",
      "ITM",
      "IXI",
      "IXL",
      "JOG",
      "JUL",
      "KCH",
      "KGC",
      "KOJ",
      "KOS",
      "LBJ",
      "LHE",
      "LLI",
      "LPQ",
      "MGA",
      "MLA",
      "MRU",
      "MYY",
      "NAG",
      "OHD",
      "OTP",
      "OVD",
      "PBH",
      "PDV",
      "PPS",
      "PTP",
      "PTY",
      "PUQ",
      "PUW",
      "RAK",
      "SCT",
      "SGU",
      "SJJ",
      "SKD",
      "SKZ",
      "SOF",
      "TAG",
      "TBS",
      "TGD",
      "TIA",
      "TLL",
      "TND",
      "TNR",
      "VOL",
      "WVB",
      "XMN",
      "YZP",
    ],
  },
  {
    name: "Scuba Diving",
    icon: ScubaDivingIcon,
    airports: [
      "BOG",
      "BON",
      "BZE",
      "CEB",
      "CNS",
      "CTG",
      "CZM",
      "DPS",
      "GCM",
      "GND",
      "HIR",
      "HKT",
      "IPC",
      "LIR",
      "MEX",
      "MLA",
      "MNL",
      "MPM",
      "NAN",
      "OGG",
      "PLS",
      "PTP",
      "ROR",
      "RTB",
      "SEZ",
      "SIG",
      "SJO",
      "SJU",
      "TNR",
      "UIO",
      "VLI",
    ],
  },
  {
    name: "Mountain",
    icon: PanoramaIcon,
    airports: [
      "ADD",
      "ALA",
      "ALB",
      "ANC",
      "BEY",
      "BHO",
      "BNA",
      "BNE",
      "BOS",
      "BTS",
      "BTV",
      "BUD",
      "CHC",
      "CHO",
      "CLT",
      "CMN",
      "DEN",
      "DYU",
      "ERC",
      "EZE",
      "GVA",
      "HAJ",
      "HET",
      "HND",
      "ICN",
      "ISB",
      "JAC",
      "JRO",
      "JUL",
      "KBL",
      "KBP",
      "KRK",
      "KTM",
      "KYZ",
      "LHW",
      "LIM",
      "LPP",
      "LUK",
      "LYS",
      "MCT",
      "MRV",
      "MXP",
      "NBO",
      "OKA",
      "OTP",
      "OVB",
      "PDX",
      "PER",
      "PHX",
      "PMV",
      "POM",
      "PRG",
      "RNO",
      "RZE",
      "SCL",
      "SEA",
      "SKG",
      "SKP",
      "SOF",
      "SPU",
      "STR",
      "SVX",
      "SXB",
      "SZG",
      "TBS",
      "TGD",
      "THR",
      "TUS",
      "TYS",
      "USH",
      "UUD",
      "VCE",
      "VVO",
      "WRO",
      "XIY",
      "YEG",
      "YYC",
      "ZRH",
    ],
  },
  {
    name: "Golf",
    icon: SportsGolfIcon,
    airports: [
      "AGS",
      "AUS",
      "CDG",
      "CHS",
      "CPT",
      "CUN",
      "DUB",
      "DXB",
      "XNB",
      "EDI",
      "GLA",
      "JHM",
      "MCO",
      "MEL",
      "MRY",
      "NRT",
      "NTY",
      "OGG",
      "OTH",
      "PIK",
      "PUJ",
      "SAN",
      "SAV",
      "SFO",
      "SJD",
      "SNN",
      "SSI",
      "YQY",
      "YVR",
    ],
  },
  {
    name: "Fishing",
    icon: PhishingIcon,
    airports: [
      "AKL",
      "ANC",
      "BDA",
      "BGI",
      "BME",
      "BZE",
      "CHC",
      "CHS",
      "CNS",
      "CPT",
      "CUN",
      "DAR",
      "DUB",
      "DXB",
      "XNB",
      "FLL",
      "GIG",
      "HEL",
      "HKT",
      "INV",
      "JNU",
      "KTN",
      "MBA",
      "MLE",
      "NAN",
      "NAS",
      "NOU",
      "ORK",
      "OSL",
      "PDX",
      "PNH",
      "PPT",
      "PVR",
      "SAN",
      "SEA",
      "SIT",
      "SJD",
      "SJU",
      "TOS",
      "ZIH",
    ],
  },
];

export default airportTags;
